import React, { useMemo } from 'react';
import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';
import { importFromS3 } from '../../utils/importFromS3';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';
import { Operation } from '../../hooks/useOperations/types';

interface InSeasonPluginContainerProps {
  operations: Operation[];
  operationsSelected: string[];
}

const S3Plugin = React.lazy(() => importFromS3('tcc-in-season-web'));

export const InSeasonPluginContainer: React.FC<InSeasonPluginContainerProps> = ({ operations, operationsSelected }) => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags['web.inSeason.module-federation'];

  const InSeasonPlugin = useMemo(() => {
    if (useModuleFederation) {
      return React.lazy(() => import('inSeasonWeb/InSeasonWeb'));
    }
    return S3Plugin;
  }, [useModuleFederation]);

  const { operation: impersonatedOperation } = useImpersonatedOperation();

  const operationIds = impersonatedOperation
    ? [impersonatedOperation.operationId]
    : operationsSelected;

  return (
    <InSeasonPlugin operations={operations} operationsSelected={operationIds} />
  );
};
